export default __webpack_public_path__ + "static/media/home_pic4.db55a74b.png";